export const fileItemHeaders = [
  { key: "type", title: "Тип файла", width: "200px" },
  { key: "name", title: "Имя файла", width: "190px", isLink: true },
  { key: "format", title: "Расширение файла", width: "150px" },
  { key: "previewStatus", title: "Статус предпросмотра", width: "230px" },
];
